import axios, { AxiosRequestConfig } from 'axios';
import { Auth } from "aws-amplify";
import * as _ from 'lodash';

export const defaultConfig: AxiosRequestConfig = {
    baseURL: 'https://94zmwnuo9e.execute-api.us-east-2.amazonaws.com/test',
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json',
        // 'Authorization': ''
        },
    timeout: 20000,
};

export const get = async (link: string, params?: object) => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.get(link, _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }, {params: {
        ...params
    }}))
};

export const post = (link: string, data?: any, shadowName?: string, params?: object) => {
    return Auth.currentSession().then(
        (res) => {
            const deviceName = _.get(res, 'accessToken.payload.username', '');
            const dataToSend = _.assign({}, {
                deviceName: deviceName,
                shadowName: shadowName,
                data: data,
                ...params
            })
            return axios.post(link, dataToSend, _.assign(defaultConfig, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': res.getAccessToken().getJwtToken()
                }
            }, ))
        }
    )
};

export const put = (link: string, data?: any, config = defaultConfig) => {
    return Auth.currentSession().then(
        (res) => {
            return axios.put(link, data, _.assign(defaultConfig, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': res.getAccessToken().getJwtToken()
                }
            }))
        }
    )
};

export const remove = (link: string, config = defaultConfig) => {
    return Auth.currentSession().then(
        (res) => {
            return axios.delete(link, _.assign(defaultConfig, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': res.getAccessToken().getJwtToken()
                }
            }))
        }
    )
};